export enum DisplayType {
    TEXT,
    TEXT_ARRAY,
    HEIGHT,
    IMAGE,
    DATE,
    IMAGE_WITH_BORDER,
    MULTI_IMAGE
}

